import React, { useEffect, useRef } from 'react';
import { ArrowDown } from 'lucide-react';
import SplitText from '../motion/SplitText';
import '../../styles/hero.css';

const Hero = () => {
  const auroraRef = useRef(null);

  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;
    let frame = 0;
    const onScroll = () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        const y = window.scrollY;
        if (auroraRef.current && y < window.innerHeight * 1.2) {
          auroraRef.current.style.transform = `translate3d(0, ${y * 0.25}px, 0)`;
        }
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      if (frame) cancelAnimationFrame(frame);
    };
  }, []);

  return (
    <header className="hero" id="hero">
      <div className="hero-aurora" ref={auroraRef} aria-hidden="true">
        <span className="aurora aurora--blue" />
        <span className="aurora aurora--gold" />
      </div>

      <div className="shell hero-inner">
        <p className="eyebrow hero-eyebrow">Angers · France</p>

        <h1 className="hero-title">
          <SplitText text="Kévin" delay={120} />
          <SplitText text="Gelineau" className="hero-title-accent" delay={260} />
        </h1>

        <div className="hero-meta">
          <p className="hero-role">
            UX/UI Designer <span className="hero-sep">·</span> Intégrateur Front-End
          </p>
          <p className="hero-pitch">
            Je conçois des interfaces pensées pour les utilisateurs et prêtes pour les
            développeurs. Du wireframe Figma à l'intégration, sans friction.
          </p>
        </div>

        <div className="hero-foot">
          <a href="#work" className="hero-cue" aria-label="Aller aux projets">
            <span className="hero-cue-line" aria-hidden="true" />
            <span className="hero-cue-label">Projets réalisés</span>
            <ArrowDown size={16} aria-hidden="true" />
          </a>

          <p className="hero-status">
            <span className="hero-status-dot" aria-hidden="true" />
            Disponible — freelance &amp; agence
          </p>
        </div>
      </div>
    </header>
  );
};

export default Hero;
